<div
  *ngIf="(isImpersonating$ | async) === true"
  class="prs-impersonation-banner prs-account-strip"
  data-testing-id="csr-impersonation-banner"
  role="status"
>
  <div class="prs-account-strip__main">
    <span class="prs-account-strip__label">{{ 'impersonation.banner.label' | translate }}</span>
    <span class="prs-impersonation-banner__text">{{ (displayName$ | async) || '' }}</span>
    <button
      type="button"
      class="btn btn-sm prs-account-strip__exit"
      data-testing-id="csr-impersonation-exit"
      [disabled]="busy"
      (click)="exit()"
    >
      {{ 'impersonation.banner.exit' | translate }}
    </button>
  </div>
</div>
